{
  "moreActions": "Περισσότερες ενέργειες"
}
